import { render, staticRenderFns } from "./ContractGroupsList.vue?vue&type=template&id=53877ede"
import script from "./ContractGroupsList.vue?vue&type=script&lang=js"
export * from "./ContractGroupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports